import { EmptyQuestionImage } from '@/src/assets/icons'
import { Typography } from '@mui/material'
import { Question } from '@/pages/announcement-detail/[slug]'

interface Props {
  handleAskQuestion: () => void
  data?: Question
}

const EmptyQuestions = (_props: Props) => {
  return (
    <div className="h-full w-full flex flex-col items-center gap-4 mb-4">
      <EmptyQuestionImage />
      <div className="flex flex-col justify-center items-center gap-2">
        <Typography
          variant="body1"
          color="text.secondary"
          className="text-center flex items-center gap-4"
        >
          No questions have been asked yet.
        </Typography>
      </div>
    </div>
  )
}

export default EmptyQuestions
